<template>
  <div>
    <app-form v-bind:parentObject="{
      data: this.formData,
      pageTitle: this.pageTitle,
      pageTitleValue: this.pageTitleValue,
      errMsg: this.errMsg,
      isEdit: this.editMode,
    }" v-on:input="formData = $event" v-on:save="saveHandler" />
    <div v-if="isErr">
      <app-error v-bind:parentError="{
        data: this.errMsg,
        isErr: this.isErr,
      }" v-on:closeError="isErr = $event" />
    </div>
  </div>
</template>

<script>

import MainForm from "../../../components/payroll/arrearstransaction/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": MainForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('arrearsexercise.createarrearstransaction'),
      pageTitleValue: "",
      formData: {
        staffid: null,
        bpexerciseid: null,
        bpexercisepoid: null,
        payitemid: null,
        quantity: null,
        oldamt: null,
        newamt: null,
        diffamt: null,
        crcyid: null,
        topay: true,
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      this.$store.dispatch('post', { url: "/arrearstransaction/create", payload: this.formData })
        .then((res) => {
          if (res.data.error) {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "arrearstransactionlist" });
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "arrearstransactionlist" });
    },
  },
};
</script>